import { useRef as _, useMemo as x, useCallback as I, useEffect as b } from "react";
import { usePrevious as A } from "./usePrevious.js";
import { useChatbotState as ue } from "./useChatbotState.js";
import { getCurrentChatSessionInfo as he, setCurrentChatSessionInfo as X, appendCurrentChatSessionUsedSuggestions as fe } from "../utils/chat-session-storage.js";
function we({
  // dependency injection
  cn: c,
  cuid: k,
  uuid: F,
  formatDate: Z,
  Markdown: J,
  remarkGfm: K,
  rehypeHighlight: Q,
  ReactTextareaAutosize: V,
  useChat: D,
  ...n
}) {
  const B = _(null), w = _(null), S = _(!1), [W, h] = ue(), { status: y, initChatbotResponse: Y, predictionId: g, hydrateError: P, isRestart: T } = W, { chatbot: e, activeSessionMessages: m, sessionId: a } = ye(Y), $ = y === "ended", { isBuilder: j, onError: s, onEvent: l } = n, q = _(!1), {
    messages: o,
    setMessages: v,
    setInput: L,
    input: O,
    handleInputChange: p,
    handleSubmit: z,
    status: u,
    error: R
    // TODO - uncomment next line to return data, which may contain additional data
    // from the chat API call.
    // data,
  } = D({
    api: n.chatEndpoint,
    streamProtocol: "data",
    id: a,
    headers: n.extraChatHeaders,
    credentials: "include",
    experimental_prepareRequestBody() {
      return {
        ...n.extraChatBodyData,
        stream: !0,
        chatbotSessionId: a ?? "",
        predictionId: g ?? "",
        message: { content: O }
      };
    },
    initialMessages: m ?? n.initialMessages,
    onError(t) {
      h({
        type: "ERROR",
        error: t
      }), !j && e && a && l(
        {
          type: "chat-error",
          chatbotId: e.id,
          sessionId: a,
          error: t
        },
        { chatbot: e, messages: o }
      ).catch((i) => {
        console.warn("Failed to handle chat error event", i), s == null || s(i, e);
      });
    },
    onFinish(t) {
      if (h({ type: "CHAT_FINISHED", predictionId: F() }), w.current) {
        const i = w.current.querySelector("textarea");
        i && requestAnimationFrame(() => {
          q.current && i.focus();
        });
      }
      if (e && a) {
        const i = o.map((r) => ({
          id: r.id,
          role: r.role,
          content: r.content,
          createdAt: r.createdAt
        }));
        l(
          {
            type: "chat-finish",
            chatbotId: e.id,
            sessionId: a,
            message: t
          },
          { chatbot: e, messages: i.concat(t) }
        ).catch((r) => {
          console.warn("Failed to handle chat finish event", r), s == null || s(r, e);
        });
      }
    },
    sendExtraMessageFields: !0,
    generateId: k
  }), ee = x(() => {
    var t;
    return n.isBuilder ? [] : e ? ((t = he(e.id)) == null ? void 0 : t.usedSuggestions) ?? [] : [];
  }, [e, n]), E = A(n.chatbotId), H = A(n.isReadonly), N = A(
    u === "streaming" || u === "submitted"
  ), te = o.some((t) => t.role === "user"), ne = o.some((t) => t.role !== "user"), ie = x(() => {
    const t = o[o.length - 1];
    if (!(R !== void 0 || !t || !(t.role === "user" && (u === "streaming" || u === "submitted") || t.role === "assistant" && t.content === "")))
      return t.createdAt;
  }, [R, u, o]), ae = x(
    () => !!(e != null && e.isLocked || !n.isBuilder && n.isPreview && (e != null && e.previewUrlDisabled) && !n.isEmbedded),
    [e, n]
  ), oe = I(
    (t, i) => {
      if (!n.chatbotId || !e || !a)
        return;
      const r = Promise.resolve();
      r.then(async () => {
        try {
          await l(
            {
              type: "tracking",
              chatbotId: e.id,
              sessionId: a,
              fields: {
                interaction_raw_text: i.buttonText,
                interaction_goal: "run zap with bot response",
                event_action: "click"
              }
            },
            { chatbot: e, messages: o }
          );
        } catch (d) {
          console.warn("Failed to handle tracking event", d);
        }
      }), r.then(() => l(
        {
          type: "action",
          chatbotId: e.id,
          sessionId: a,
          messageId: t.id,
          actionId: i.id
        },
        { chatbot: e, messages: o }
      )).catch((d) => {
        console.warn("Failed to handle action", d), n.onEvent(
          {
            type: "error",
            chatbotId: e.id,
            sessionId: a,
            error: d
          },
          { chatbot: e, messages: o }
        ).catch((f) => {
          console.warn("Failed to handle error event", f), s == null || s(f, e);
        });
      });
    },
    [e, o, s, l, n, a]
  ), se = I(
    (t, i = !1) => {
      if (!n.chatbotId || !e || !a)
        return;
      Promise.resolve().then(() => l(
        {
          type: "link-click",
          chatbotId: e.id,
          sessionId: a,
          linkUrl: t,
          isButtonClick: i
        },
        { chatbot: e, messages: o }
      )).catch((d) => {
        console.warn("Failed to handle link click", d), n.onEvent(
          {
            type: "error",
            chatbotId: e.id,
            sessionId: a,
            error: d
          },
          { chatbot: e, messages: o }
        ).catch((f) => {
          console.warn("Failed to handle error event", f), s == null || s(f, e);
        });
      });
    },
    [e, o, s, l, n, a]
  ), re = I(
    (t, i) => {
      var f;
      const r = Ie(t.data);
      if (!n.chatbotId || !e || !a || ((f = n.extraChatBodyData) == null ? void 0 : f.mode) === "preview")
        return;
      const d = Promise.resolve();
      r && d.then(async () => {
        try {
          await l(
            {
              type: "tracking",
              chatbotId: e.id,
              sessionId: a,
              fields: {
                prediction_id: r,
                correlation_id: a,
                user_rating: i > 0 ? "EXPLICIT_GOOD" : "EXPLICIT_BAD",
                user_feedback: null,
                corrected_prediction_json_output: null,
                release_id: null,
                zap_id: null
              }
            },
            { chatbot: e, messages: o }
          );
        } catch (C) {
          console.warn("Failed to handle tracking event", C);
        }
      }), d.then(() => l(
        {
          type: "feedback",
          chatbotId: e.id,
          sessionId: a,
          messageId: t.id,
          rating: i
        },
        { chatbot: e, messages: o }
      )).catch((C) => {
        console.warn("Failed to handle feedback", C), n.onEvent(
          {
            type: "error",
            chatbotId: e.id,
            sessionId: a,
            error: C
          },
          { chatbot: e, messages: o }
        ).catch((G) => {
          console.warn("Failed to handle error event", G), s == null || s(G, e);
        });
      }).finally(() => {
        typeof t.data != "object" ? t.data = { rating: i } : t.data = { ...t.data, rating: i };
      });
    },
    [e, o, s, l, n, a]
  ), de = I(
    (t, i) => (e && a && (X(e.id, {
      sessionId: a,
      lastMessageSentAt: Date.now()
    }), l(
      {
        type: "tracking",
        chatbotId: e.id,
        sessionId: a,
        fields: {
          interaction_raw_text: null,
          interaction_goal: "send message in chatbot",
          event_action: "prompt"
        }
      },
      { chatbot: e, messages: o }
    ).catch((r) => {
      console.warn("Failed to handle tracking event", r), s == null || s(r, e);
    })), q.current = !0, z(t, {
      ...i,
      body: {
        ...i == null ? void 0 : i.body,
        predictionId: g
      }
    })),
    [
      e,
      z,
      o,
      s,
      l,
      g,
      a
    ]
  ), ce = I(
    (t) => {
      const { id: i, message: r } = t.currentTarget.dataset;
      !i || !r || (e && a && fe(e.id, r), L(r), requestAnimationFrame(() => {
        const d = B.current;
        d && (d.requestSubmit ? d.requestSubmit() : d.submit());
      }));
    },
    [e, L, a]
  ), le = I(
    (t) => {
      if (t.preventDefault(), w.current) {
        const i = w.current.querySelector("textarea");
        i && requestAnimationFrame(() => {
          i.focus();
        });
      }
    },
    []
  ), U = I(async () => {
    try {
      if (h({ type: "INITIALIZING" }), !n.chatbotId)
        throw new Error("Chatbot ID is missing");
      const t = await n.init(n.chatbotId, {
        isRestart: T
      });
      if (h({
        type: "INITIALIZED",
        initChatbotResponse: t,
        predictionId: F()
      }), t.error)
        throw new Error(t.error);
    } catch (t) {
      h({
        type: "ERROR",
        error: t instanceof Error ? t : new Error(String(t))
      });
    }
  }, [h, T, n, F]), M = I(async () => {
    S.current = !1, h({ type: "RESET" });
  }, [h]);
  return b(() => {
    y === "idle" && S.current === !1 && (S.current = !0, U());
  }, [U, y]), b(() => {
    S.current && !n.isReadonly && o.length === 0 && (e != null && e.defaultMessage) && v(
      m != null && m.length ? m : [
        {
          id: k(),
          role: "assistant",
          content: e.defaultMessage
        }
      ]
    );
  }, [
    m,
    e,
    k,
    n.isReadonly,
    o.length,
    v
  ]), b(() => {
    e != null && e.id && a && X(e.id, { sessionId: a });
  }, [a, e == null ? void 0 : e.id]), b(() => {
    (n.chatbotId && E && n.chatbotId !== E || H && !n.isReadonly) && M();
  }, [
    M,
    E,
    n.chatbotId,
    n.isReadonly,
    H
  ]), b(() => {
    if (N && u === "ready" && g) {
      const t = o.filter((i) => i.role === "assistant").pop();
      v(
        o.map((i) => ({
          ...i,
          data: i.id === (t == null ? void 0 : t.id) ? { predictionId: g } : i.data
        }))
      );
    }
  }, [N, u, o, v, g]), b(() => {
    n.isReadonly && v(n.initialMessages);
  }, [n.initialMessages, n.isReadonly, v]), {
    ...n,
    chatbot: e,
    chatError: R,
    chatStatus: u,
    formRef: B,
    hydrateError: P,
    input: O,
    handleAction: oe,
    handleLinkClick: se,
    handleFeedback: re,
    handleInputChange: p,
    handleSubmit: de,
    handleSuggestion: ce,
    handleScroll: le,
    handleRestart: M,
    isDisabled: ae,
    isEmptyConversation: !!n.isReadonly && o.length === 0,
    isEnded: $,
    isError: (y === "error" || !!P) && !R,
    isInitializing: y === "idle" || y === "initializing",
    isLoading: u === "streaming" || u === "submitted",
    messages: o.filter(
      (t) => t.role !== "user" || t.content !== ""
    ),
    promptRef: w,
    thinkingTimestamp: ie,
    hasUserMessages: te,
    hasBotMessages: ne,
    sessionId: a,
    previouslyUsedSuggestions: ee,
    // dependency injection
    cn: c,
    formatDate: Z,
    Markdown: J,
    remarkGfm: K,
    rehypeHighlight: Q,
    ReactTextareaAutosize: V,
    useChat: D
  };
}
function Ie(c) {
  return typeof c == "object" && c != null && "predictionId" in c && typeof c.predictionId == "string" ? c.predictionId : null;
}
function ye(c) {
  return c ? {
    chatbot: {
      ...c,
      activeSessionMessages: void 0,
      chatbotSessionId: void 0
    },
    sessionId: c.chatbotSessionId,
    activeSessionMessages: c.activeSessionMessages
  } : {
    chatbot: void 0,
    sessionId: void 0,
    activeSessionMessages: void 0
  };
}
export {
  we as useChatbotConversation
};
